export const simpleSoundCheckin = () => {
  const audioCheckin = new Audio('https://bizz-dome.com/sound/b1.mp3')
  audioCheckin.play()
}
